import {
    Button,
    MenuItem,
    Modal,
    TextField,
    InputAdornment,
    Autocomplete
} from "@mui/material";
import { React, useState, useContext, useEffect } from 'react'
import request from "../../../../Helpers/API";
import Swal from "sweetalert2";
import { FormatMoney } from "../../../../Helpers/FormatNumber";

const ModalOrden = ({ folio = 0, cliente, onClose, open }) => {


    const [orden, setOrden] = useState([]);
    const [vendedores, setVendedores] = useState([]);

    const [powergard, setPowergard] = useState({
        sucursal: "",
        cliente: "",
        ot: "",
        serie: "",
        costo: 0,
        facturacion: 0,
        fechaFacturacion: "",
        cobertura: "",
        tipo: "",
        vendedor: 0
    });

    // const Editar = () => {

    //     if (idpowergard !== null || idpowergard !== "" || idpowergard !== -1 || idpowergard !== undefined) {
    //         request
    //             .get(`Powergard/ObtenerID?idpowergard=${idpowergard}`)
    //             .then((result) => {
    //                 const rawFecha = result.fecha_facturacion;
    //                 const fecha = new Date(rawFecha);

    //                 const fechaFormateada = fecha.toISOString().split('T')[0];
    //                 console.log(result)
    //                 setPowergard({
    //                     ...powergard,
    //                     sucursal: result.idsucursal,
    //                     cliente: result.idcliente,
    //                     ot: result.num_ot,
    //                     serie: result.serie,
    //                     costo: result.costo,
    //                     facturacion: result.facturacion,
    //                     fechaFacturacion: fechaFormateada,
    //                     cobertura: result.cobertura,
    //                     tipo: result.tipo,
    //                     vendedor: result.idvendedor
    //                 })
    //             })
    //             .catch((error) => {
    //                 Swal.fire("INTERESES", JSON.stringify(error), "error");
    //             });

    //     } else {
    //         return;
    //     }
    // }

    // useEffect(() => {

    //     if (idpowergard !== undefined && idpowergard !== null && Number(idpowergard) > 0) {
    //         Editar();
    //     } else {

    //     }
    // }, [updatedata]);

    const onCerrar = () => {
        setPowergard({
            ...powergard,
            sucursal: 0,
            cliente: "",
            ot: "",
            serie: "",
            costo: 0,
            facturacion: 0,
            fechaFacturacion: "",
            cobertura: "",
            tipo: "",
            vendedor: 0
        })
        onClose()
    }


    useEffect(() => {
        request
            .get(`DashboardPostventa/ObtenerOrden?folio=${folio}`)
            .then((result) => {
                setOrden(result);
            })
            .catch((error) => {
                Swal.fire("CLIENTES", JSON.stringify(error), "error");
            });
    }, [folio]);


    const sumaSubtotal = orden.reduce(
        (acc, item) => acc + Number(item.subtotal || 0),
        0
    );

    const sumaDescuento = orden.reduce(
        (acc, item) => acc + Number(item.descuento || 0),
        0
    );

    const sumaTotal = orden.reduce(
        (acc, item) => acc + Number(item.total || 0),
        0
    );

    return (
        <Modal open={open}>
            <div className="modal-orden-cotizacion-main-container">
                <div className="cerrar-modal-button" onClick={onCerrar}>
                    X
                </div>
                <div className="credito-agregar-modal-title">

                    <div className="modal-agregar-powergard-main-titulo">
                        <div className="modal-agregar-powergard-main-titulo-cliente">{cliente} </div>
                        <div className="modal-agregar-powergard-main-titulo-folio">Folio: {folio} </div>
                    </div>
                </div>
                <div className="modal-tasa-intereses-filtro-soy-el-titulo-line">
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-bl"></div>
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-circle"></div>
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-br"></div>
                </div>

                <div className="modal-orden-info-main-container scroll">
                    {orden.length > 0 ? (
                        <table cellPadding={0} cellSpacing={0}>
                            <thead>
                                <tr>
                                    <th>
                                        Orden
                                    </th>
                                    <th>
                                        Descripcion
                                    </th>
                                    <th>
                                        <div> Disponible</div>
                                    </th>
                                    <th>
                                        <div> Cantidad</div>
                                    </th>
                                    <th>
                                        <div>Precio</div>
                                    </th>
                                    <th>
                                        <div>Subtotal</div>
                                    </th>
                                    <th>
                                        <div>Descuento</div>
                                    </th>
                                    <th>
                                        <div>Total</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* <tr >
                                <td className="">
                                    {"1"}
                                </td>
                                <td className="td-contacto">{"Caucho inteligente"}</td>
                                <td className="td-contacto">{"8"}</td>
                                <td className="td-contacto">{"2"}</td>
                                <td className="td-contacto">{"1,000"}</td>
                                <td className="td-contacto">{"2,000"}</td>
                            </tr> */}
                                {orden.map((item, index) => (
                                    <tr key={index}>
                                        <td className="">
                                            {item.columna}
                                        </td>
                                        <td className="td-comentario">
                                            {item.descripcion}
                                        </td>
                                        <td className="td-moneda">
                                            {item.disponible}
                                        </td>
                                        <td className="td-moneda">
                                            {item.cantidad}
                                        </td>
                                        <td className="td-moneda">
                                            {FormatMoney(item.precio, 2)}
                                        </td>
                                        <td className="td-moneda">
                                            {FormatMoney(item.subtotal, 2)}
                                        </td>
                                        <td className="td-moneda">
                                            {FormatMoney(item.descuento, 2)}
                                        </td>
                                        <td className="td-moneda">
                                            {FormatMoney(item.total, 2)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>

                            <tfoot>
                                <tr>
                                    <td colSpan={5} className="ta-center">
                                        <strong>Totales</strong>
                                    </td>
                                    <td className="td-moneda">
                                        <strong>{FormatMoney(sumaSubtotal, 2)}</strong>
                                    </td>
                                    <td className="td-moneda">
                                        <strong>{FormatMoney(sumaDescuento, 2)}</strong>
                                    </td>
                                    <td className="td-moneda">
                                        <strong>{FormatMoney(sumaTotal, 2)}</strong>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    ) : (
                        <table cellPadding={0} cellSpacing={0}>
                            <thead>
                                <tr>
                                    <th>
                                        Orden
                                    </th>
                                    <th>
                                        Descripcion
                                    </th>
                                    <th>
                                        <div> Disponible</div>
                                    </th>
                                    <th>
                                        <div> Cantidad</div>
                                    </th>
                                    <th>
                                        <div>Precio</div>
                                    </th>
                                    <th>
                                        <div>Subtotal</div>
                                    </th>
                                    <th>
                                        <div>Descuento</div>
                                    </th>
                                    <th>
                                        <div>Total</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr >
                                    <td colSpan={8} className="ta-center">
                                        No se encontro la orden
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    )
                    }

                </div>

                {/* <div className="credito-crear-tasa-interes-modal-button-container ">
                    <Button onClick={onCerrar} variant="contained" color="error">
                        Cerrar
                    </Button>
                    <Button variant="contained"
                    // onClick={() => onGuardar()}
                    >
                        Agregar
                    </Button>
                </div> */}
            </div>
        </Modal>
    )
}

export default ModalOrden
